/* eslint-disable @typescript-eslint/no-unused-expressions */
// import { Select } from 'antd';
import { Avatar, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { PopupModal } from 'react-calendly';
import { NavLink, useNavigate } from 'react-router-dom';
import { Typography } from 'tfc-components';

import logoEvol from 'assets/images/logo_evol.png';
import Button from 'components/atoms/Button';
// import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import Container from 'components/organisms/Container';
import useWindowDimensions from 'hooks/useWindowDemensions';
import { getAccessToken } from 'services/common/storage';
import { useAppSelector } from 'store/hooks';
import mapModifiers, { getFirstLetters } from 'utils/functions';

export interface MenuProps {
  href: string;
  label: string;
}

interface HeaderWebProps {
  menu: MenuProps[];
  extendClasses?: string;
}

const HeaderWeb: React.FC<HeaderWebProps> = ({ menu, extendClasses }) => {
  const { height } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [fixed, setFixed] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const navigation = useNavigate();
  const profile = useAppSelector((state) => state.auth.profile);
  const token = getAccessToken();
  const toggleSidebar = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        open
        && sidebarRef.current
        && !sidebarRef.current.contains(event.target as Node)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={`${mapModifiers('o-headerWeb', fixed && 'fixed')}${extendClasses ? ` ${extendClasses}` : ''
        }`}
    >
      <Container fullWidth>
        <div className="o-headerWeb_wrapper">
          <div className="o-headerWeb_logo">
            <Image
              ratio="205x42"
              src={logoEvol}
              alt="Logo Evol"
              size="contain"
              className="t-login_logo"
            />
            {' '}

          </div>
          <div
            className={mapModifiers('o-headerWeb_content', open && 'open')}
            style={{ '--var-height': `${height}px` } as React.CSSProperties}
          >
            <div className="o-headerWeb_menu">
              <div className="o-headerWeb_menu_list">
                {menu.map((item) => (
                  <NavLink
                    to={item.href}
                    className={({ isActive }) => mapModifiers('o-headerWeb_menu_item', isActive && 'active')}
                    onClick={closeSidebar}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </div>
            {/* <div className="o-headerWeb_language">
              <Icon iconName="webAppActive" size="20" />
              <Select
                bordered={false}
                className="o-headerWeb_language_select"
                placeholder="Vie"
                defaultValue={
                  { label: 'Vie', value: 'vi' }
                }
                options={[{
                  label: 'Vie',
                  value: 'vi'
                }, {
                  label: 'Eng',
                  value: 'en'
                }]}
              />
            </div> */}
          </div>
          <div className="o-headerWeb_actions">
            <div className="o-headerWeb_actions_buttonContainer">
              {token && profile ? (
                <Tooltip placement="bottom" title="Go to Portal">
                  <Avatar style={{ backgroundColor: '#012B61' }} alt={profile?.customerData.name} onClick={() => navigation('/home')} className="o-headerWeb_actions_avatar" src={profile.customerData.avatar} size={40}>
                    {!profile.customerData.avatar && (
                      <Typography.Text extendClasses="f-14x16">
                        {getFirstLetters(profile.customerData.name || '')}
                      </Typography.Text>
                    )}
                  </Avatar>
                </Tooltip>
              ) : (
                <Button
                  onClick={() => (token ? navigation('/home') : navigation('/login'))}
                  className="fButton fButton-sm o-headerWeb_actions_button"
                >
                  <Typography.Text extendClasses="f-14x20" fontweight="600">
                    Login
                  </Typography.Text>
                </Button>
              )}
              <Button onClick={() => setIsOpen(true)} className="fButton fButton-sm">
                <Typography.Text extendClasses="f-14x20" fontweight="600">
                  Book a Demo
                </Typography.Text>
              </Button>
            </div>
            <button
              type="button"
              className={mapModifiers('o-headerWeb_hamburger', open && 'open')}
              onClick={toggleSidebar}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </Container>
      <PopupModal
        pageSettings={{ primaryColor: '#f96619' }}
        open={isOpen}
        onModalClose={() => setIsOpen(false)}
        url="https://calendly.com/askly-demo/schedule?hide_gdpr_banner=1"
        rootElement={document.getElementById('root') || document.body}
      />
    </header>

  );
};

export default HeaderWeb;
